export const ADDRESS_SIZE = 64n;
